const subscribeRoute = {
  SUBSCRIBE_STEP_1: '/subscribe',
}

export default subscribeRoute
